/* Confordrive — páginas "Tapetes específicos" (v2). O H1, os passos, o aviso e o JSON-LD vêm do servidor
   (snippets/cf-seo-page.liquid); aqui só a pesquisa e as classes de layout. Mantém compatibilidade com páginas sem SSR. */
(function () {
  var root = document.querySelector('.cf-pnav[data-passo]');
  if (!root) return;
  var passo = +root.getAttribute('data-passo');
  var nome = root.getAttribute('data-nome') || '';
  var back = root.getAttribute('data-back') || '/pages/tapetes-especificos';
  var flow = root.querySelector('.cf-tapflow');
  var grid = root.querySelector('.cf-pnav__grid');
  if (!flow || !grid) return;

  if (!flow.querySelector('.cf-tapflow__steps')) {
    var steps = [['Marca', 'Escolha o fabricante'], ['Modelo', 'Escolha a família'], ['Geração', 'Confirme os anos'], ['Tapetes', 'Veja os compatíveis']];
    var html = '<h1 class="cf-tapflow__title">Tapetes ' + nome + '</h1><ol class="cf-tapflow__steps" aria-label="Etapas para escolher os tapetes">';
    steps.forEach(function (s, i) {
      var cls = i + 1 < passo ? ' is-done' : i + 1 === passo ? ' is-active' : '';
      html += '<li class="cf-tapflow__step' + cls + '"><span class="cf-tapflow__num">' + (i + 1) + '</span><span class="cf-tapflow__copy"><strong>' + s[0] + '</strong><small>' + s[1] + '</small></span></li>';
    });
    html += '</ol><a class="cf-tapflow__back" href="' + back + '">← Alterar ' + (passo === 2 ? 'marca' : 'modelo') + '</a>';
    flow.insertAdjacentHTML('afterbegin', html);
  }

  var cards = [].slice.call(grid.querySelectorAll('.cf-pnav__card'));
  var un = passo === 2 ? ['modelo disponível', 'modelos disponíveis'] : ['geração disponível', 'gerações disponíveis'];
  var ex = cards.slice(0, 2).map(function (c) { var m = c.querySelector('.cf-pnav__model'); return m ? m.textContent : ''; }).join(' ou ');
  grid.insertAdjacentHTML('beforebegin', '<div class="cf-pnav__toolbar"><div><span class="cf-pnav__summary"></span></div><div class="cf-pnav__search-wrap"><label class="cf-pnav__search-label" for="cf-pnav-search">' + (passo === 2 ? 'Pesquisar modelo' : 'Pesquisar geração ou ano') + '</label><input id="cf-pnav-search" class="cf-pnav__search" type="search" placeholder="Ex.: ' + ex + '" autocomplete="off"></div></div>');
  grid.insertAdjacentHTML('afterend', '<p class="cf-pnav__empty">Não encontrámos resultados para ' + nome + '.</p>');
  var q = root.querySelector('.cf-pnav__search'), sum = root.querySelector('.cf-pnav__summary'), empty = root.querySelector('.cf-pnav__empty');
  function run() {
    var v = (q.value || '').toLowerCase().trim(), n = 0;
    cards.forEach(function (c) { var ok = !v || c.textContent.toLowerCase().indexOf(v) > -1; c.style.display = ok ? '' : 'none'; if (ok) n++; });
    sum.textContent = n + ' ' + (n === 1 ? un[0] : un[1]);
    empty.style.display = n ? 'none' : 'block';
  }
  q.addEventListener('input', run); run();

  var p = root.closest('.page-width'), m = root.closest('#MainContent');
  if (p) p.classList.add('cf-tapflow-page');
  if (m) m.classList.add('cf-tapflow-main');
})();
